<div class="flex gap-[8px] items-center">
  <div class="w-[16px] h-[16px] rounded-full {{ stateColour }}"></div>
  <div class="text-b1 font-medium text-G900">{{ stateStatus }}</div>
</div>
